<div *transloco="let t" class="bg-white min-h-screen px-3 sm:px-6 lg:px-8">
  <div
    class="flex max-sm:flex-col max-sm:items-start max-sm:gap-2 space-x-2 items-center sticky pt-8 top-0 z-30 bg-white">
    <span class="font-black uppercase text-sm">{{ t("tipOffs") }} ({{ totalItems }})</span>
    <div class="flex space-x-2 w-full ">
      <app-mb-search (clearSearch)="onClearSearch()" (searchSubmit)="onSearch()" [(searchValue)]="searchValue"
        placeholder="{{ t('searchHere') }}" [width]="'w-full md:w-2xs'" class="flex-1 md:flex-none min-w-0" />
      <div (click)="showFilterModal()" (keydown.enter)="showFilterModal()" (keydown.space)="showFilterModal()"
        aria-label="Show Filter Modal" class="border border-mbaza-gray-dark h-10 rounded-sm p-2 cursor-pointer"
        tabindex="0">
        <img [src]="ASSET_CONSTANTS.I_sliders" alt="download icon"
          class="w-5 h-5 object-contain transition duration-300" />
      </div>
    </div>
  </div>
  <nz-divider />
  <app-mb-skeleton *ngIf="isLoading" [columns]='6' [rows]='8' />
  <ng-container *ngIf="!isLoading">
    <app-mb-empty-list *ngIf="!tipOffs || tipOffs.length === 0" />
    <div class="w-full overflow-x-auto [scrollbar-width:thin] [scrollbar-color:#8E8E8E]">
      <nz-table #tipOffTable *ngIf="tipOffs && tipOffs.length > 0" [nzData]="tipOffs" [nzFrontPagination]="false"
        [nzShowPagination]="false" class="min-w-max">
        <tbody>
          <tr (click)="onTipOffClick(tipoff.id)" *ngFor="let tipoff of tipOffs; let i = index"
            class="w-full text-sm cursor-pointer hover:bg-gray-50">
            <td class="font-bold px-4 py-3 whitespace-nowrap">
              {{ (currentPage - 1) * pageSize + i + 1 }}
            </td>

            <td class="font-bold whitespace-nowrap" style="min-width: 4rem;">
              <span class="border-mbaza-gray-dark border text-ellipsis rounded-full px-3 py-1.5">
                {{ tipoff.category.name | truncate:45}}
              </span>
            </td>

            <td class="font-bold px-4 py-3 truncate whitespace-nowrap" style="min-width: 4rem; max-width: 8rem;">
              {{ tipoff.title }}
            </td>

            <td class="text-mbaza-gray font-light px-4 py-3 truncate whitespace-nowrap "
              style="min-width: 4rem; max-width: 6rem;">
              {{ tipoff.description }}
            </td>

            <td class="px-4 py-3 whitespace-nowrap" style="width: 2rem;">
              <span class="font-bold">{{ t("reportedOn") }}</span> :
              {{ tipoff.createdAt | date : "dd MMM yyyy" }}
            </td>

            <td class="px-4 py-3 text-end whitespace-nowrap bg-white relative" style="width: 4rem;">
              <img [src]="ASSET_CONSTANTS.I_arrow_right" alt="arrow right"
                class="w-4 h-4 grayscale-100 absolute top-1/2 -translate-y-1/2 right-2" />
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <nz-pagination (nzPageIndexChange)="onTipOffsPageChange($event)" *ngIf="totalItems > pageSize"
      [nzPageIndex]="currentPage" [nzPageSize]="pageSize" [nzTotal]="totalItems"
      style="padding: 20px 8px; text-align: right"></nz-pagination>
  </ng-container>
</div>

<app-mb-modal (CancelActionHandler)="onTipOffModalCancelAction()" (OkActionHandler)="onTipOffModalOkAction()"
  (isVisibleChange)="isTipOffModalVisible = $event" *transloco="let t" [desktopWidth]="'50%'"
  [icon]="ASSET_CONSTANTS.I_grey_stars" [isVisible]="isTipOffModalVisible" [title]="t('form.title.anonymousComplaint')"
  [width]="'50%'">
  @if (isLoadingTipOffDetail) {
  <div class="animate-pulse flex flex-col gap-4 p-8 ">
    <!-- Title -->
    <div class="h-4 w-40 bg-gray-200 rounded"></div>
    <!-- Description (multi-line) -->
    <div class="flex flex-col gap-2">
      <div class="h-4 w-full bg-gray-200 rounded"></div>
      <div class="h-4 w-5/6 bg-gray-200 rounded"></div>
      <div class="h-4 w-4/6 bg-gray-200 rounded"></div>
    </div>
    <!-- Issue Location Header -->
    <div class="h-4 w-40 bg-gray-200 rounded mt-4"></div>
    <!-- Location Grid -->
    <div class="flex flex-row gap-4 w-full">
      @for (item of [1, 2, 3, 4]; track item) {
      <div class="flex flex-col gap-2 w-1/4">
        <div class="h-2 w-20 bg-gray-200 rounded"></div>
        <div class="h-2 w-28 bg-gray-200 rounded"></div>
      </div>
      }
    </div>
    <nz-divider />
    <!-- Supporting Attachments Header -->
    <div class="h-4 w-48 bg-gray-200 rounded"></div>
    <div class="h-10 w-40 bg-gray-200 rounded"></div>
  </div>
  }
  <div *ngIf="!isLoadingTipOffDetail"
    class="flex flex-col gap-2 p-8 max-h-[60vh] overflow-hidden hover:overflow-y-auto">
    <span class="font-black text-2xl">{{ selectedTipOff?.title }}</span>
    <p class="text-sm pr-2">{{ selectedTipOff?.description }}</p>
    <span class="font-black uppercase my-4 text-sm">{{ t("issueLocation") }}</span>
    <div class="grid grid-cols-2 gap-y-4 sm:grid-cols-4 w-full text-sm">
      <div class="flex flex-col gap-2">
        <span class="font-bold">{{ t("district") }}</span>
        <span class="text-mbaza-gray font-thin">{{
          selectedTipOff?.location?.district?.name
          }}</span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold">{{ t("sector") }}</span>
        <span class="text-mbaza-gray text-xs font-thin">{{
          selectedTipOff?.location?.sector?.name
          }}</span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold">{{ t("cell") }}</span>
        <span class="text-mbaza-gray text-xs font-thin">{{
          selectedTipOff?.location?.cell?.name
          }}</span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold">{{ t("village") }}</span>
        <span class="text-mbaza-gray text-xs font-thin">{{
          selectedTipOff?.location?.village?.name
          }}</span>
      </div>
    </div>
    <nz-divider />

    <span class="font-black  text-sm uppercase">{{ t("supportingAttachments") }}</span>
    <app-mb-document-viewer *ngIf="selectedTipOff && selectedTipOff.documents && selectedTipOff.documents.length > 0"
      [documents]="selectedTipOff.documents" />
    <span *ngIf="selectedTipOff && !selectedTipOff?.documents?.length">
      {{ t("noDocumentsFound") }}
    </span>
  </div>
</app-mb-modal>

<app-mb-modal (CancelActionHandler)="handleFilterModalCancel()" (OkActionHandler)="onTipOffModalOkAction()"
  (isVisibleChange)="isFilterModalVisible = $event" *transloco="let t" [desktopWidth]="'50%'" [footerDisabled]="true"
  [icon]="ASSET_CONSTANTS.I_grey_stars" [isVisible]="isFilterModalVisible" [title]="t('filter')" [width]="'50%'">
  <div class="p-4">
    <div class="flex flex-col space-y-6">
      <app-mb-select (handleChange)="handleFilterChange('category', $event)" [(ngModel)]="tipOffFilterForm.category"
        [hasShortText]="true" [options]="categoryOptions" [prefixLabel]="t('tipOffCategory')" class="w-full"
        placeholder="{{ t('all') }}" />
      <p class="font-bold">{{ t('byLocation') }}</p>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-1">
        <app-mb-select (handleChange)="handleFilterChange('district', $event)" [(ngModel)]="tipOffFilterForm.district"
          [hasShortText]="true" [options]="districtOptions" [prefixLabel]="t('district')" class="w-full"
          placeholder="{{ t('allDistricts') }}" />
        <app-mb-select (handleChange)="handleFilterChange('sector', $event)" [(ngModel)]="tipOffFilterForm.sector"
          [hasShortText]="true" [options]="sectorOptions" [prefixLabel]="t('sector')"
          placeholder="{{ t('allSectors') }}" />
        <app-mb-select (handleChange)="handleFilterChange('cell', $event)" [(ngModel)]="tipOffFilterForm.cell"
          [hasShortText]="true" [options]="cellOptions" [prefixLabel]="t('cell')" class="w-full"
          placeholder="{{ t('allCells') }}" />
        <app-mb-select [(ngModel)]="tipOffFilterForm.village" [hasShortText]="true" [options]="villageOptions"
          [prefixLabel]="t('village')" class="w-full" placeholder="{{ t('allVillages') }}" />
      </div>

    </div>

    <div class="flex items-center justify-between gap-1 mt-4  ">
      <app-mb-button (click)="handleFilterClear()" (keydown.enter)="handleFilterClear()"
        (keydown.space)="handleFilterClear()" label="{{ t('clearFilters') }}" type="ghost" />
      <app-mb-button (click)="handleFilterApply()" (keydown.enter)="handleFilterApply()"
        (keydown.space)="handleFilterApply()" label="{{ t('filterList') }}" type="secondary" />
    </div>

  </div>
</app-mb-modal>